'use es6';

import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

/**
 * Context for determining if the consuming app is rendering the sidebar in an iframe
 *
 * Used to disable actions that don't work well in the small screen space or can visually
 * conflict with navigation elements outside of the iframe such as
 * - preview
 * - object creation
 * - certain property inputs (i.e. contact multiple email input)
 *
 * This was first added for use in the HubSpot Gmail extension which renders a
 * sidebar inside an iframe on the gmail inbox page
 * see https://git.hubteam.com/HubSpot/sales-clients-sidebar
 *
 * @param {Boolean} [value=false] the context value, `true` if the sidebar is embedded in an iframe, `false` if mounted directly on the main browser window's page
 */

export const IsEmbeddedContext = /*#__PURE__*/createContext(false);
IsEmbeddedContext.Provider.propTypes = {
  value: PropTypes.bool.isRequired
};
export const useIsEmbeddedContext = () => useContext(IsEmbeddedContext);